// custom cells for the table
import Currency from "./Cells/Currency";
import Entity from "./Cells/Entity";
import Exchange from "./Cells/Exchange";
import Isin from "./Cells/Isin";
import Name from "./Cells/Name";
import Save from "./Cells/Save";
import Ticker from "./Cells/Ticker";
import Type from "./Cells/Type";

type Col = {
	id: string;
	Cell: (transaction: any) => JSX.Element | null;
	label: string;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "type",
		Cell: Type,
		label: "Tipo",
		align: "left"
	},
	{
		id: "name",
		Cell: Name,
		align: "left",
		label: "Nombre"
	},
	{
		id: "tickerSymbol",
		Cell: Ticker,
		align: "left",
		label: "Ticker"
	},
	{
		id: "isin",
		Cell: Isin,
		label: "ISIN",
		align: "center"
	},
	{
		id: "currency",
		Cell: Currency,
		label: "Moneda",
		align: "center"
	},
	{
		id: "exchange",
		Cell: Exchange,
		label: "Exchange",
		align: "center"
	},
	{
		id: "connectedEntity",
		Cell: Entity,
		label: "Entidad",
		align: "center"
	},
	{
		id: "save",
		Cell: Save,
		label: "",
		align: "center"
	}
];

export default cols;
